<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand"
          to="/"
        >
          <span class="brand-logo">
            <b-img
              :src="logo"
              alt="logo"
            />
          </span>
          <h2 class="brand-text mb-0">
            {{ organizationCode }}
          </h2>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import { onMounted, ref } from '@vue/composition-api'
import api from './api'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    const organizationCode = ref(null)
    const logo = ref(null)

    const { appName, appLogoImage } = $themeConfig.app
    onMounted(async () => {
      const response = await api.getOrganizationProperties()
      if (response) {
        organizationCode.value = response.orgCode
        logo.value = response.logo
      } else {
        organizationCode.value = appName
        logo.value = appLogoImage
      }
    })
    return {
      organizationCode,
      logo,
    }
  },
}
</script>
